import pxToRem from "../../functions/pxToRem";

const root = {
  display: "inline-flex" as const,
  justifyContent: "center" as const,
  alignItems: "center" as const,
  fontSize: pxToRem(13),
  fontWeight: 500,
  borderRadius: pxToRem(8),
  padding: `${pxToRem(8)} ${pxToRem(20)}`,
  lineHeight: 1.5,
  textAlign: "center" as const,
  textTransform: "none" as const,
  userSelect: "none" as const,
  backgroundSize: "150% 150%",
  backgroundPosition: "50%",
  transition: "all 150ms ease-in",
  letterSpacing: pxToRem(0.5),
  cursor: "pointer" as const,
  border: "none",

  "&:disabled": {
    pointerEvent: "none",
    opacity: 0.65,
    cursor: "not-allowed",
  },

  "& .material-icons": {
    fontSize: pxToRem(16),
    marginTop: pxToRem(-2),
  },

  "&:hover": {
    transform: "translateY(-1px)",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.12)",
  },

  "&:active": {
    transform: "translateY(0)",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.12)",
  },

  "&:focus": {
    outline: "none",
    boxShadow: "0 0 0 3px rgba(59, 130, 246, 0.15)",
  },
};

export default root;
